import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export type BackButtonVariant = 'detail' | 'checkout';

@Component({
  selector: 'app-back-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
  @Input() label = 'Back';
  /** `detail`: image arrow (course/bundle detail). `checkout`: link-style + chevron SVG. */
  @Input() variant: BackButtonVariant = 'detail';
  /** Extra bottom margin (e.g. bundle detail layout). */
  @Input() withBottomMargin = false;

  @Output() backClick = new EventEmitter<void>();

  onClick(event: Event): void {
    event.preventDefault();
    this.backClick.emit();
  }
}
